module.exports = __webpack_public_path__ + "/81826dc8e6bc9604581e4d33732b4335.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/integrations/assets/gmail.svg
 ** module id = 1603
 ** module chunks = 0
 **/